import { t } from "i18next";
import { DirectUploadMedia } from "libs/directUpload";
import { ProductsListItem } from "modules/products";
import { ProductSetsListItem } from "modules/productSets";
import * as yup from "yup";

export const bannerValidationSchema = yup.object({
  image: yup
    .mixed<DirectUploadMedia>()
    .nullable()
    .defined()
    .test(
      "is-present",
      "Image is required",
      (value) => value !== null && value !== undefined
    ),
  title: yup.string().required(t("Title is required")),
  fromPostingDate: yup.date().required(t("Posting date is required")),
  fromPostingTime: yup
    .string()
    .required(t("Posting time is required"))
    .nullable(),
  toPostingDate: yup.date().required(t("End date is required")),
  toPostingTime: yup.string().required(t("End time is required")).nullable(),
  productVariants: yup
    .array<ProductsListItem[]>(yup.object())
    .required(t("Product variants are required")),
  productSet: yup.mixed<ProductSetsListItem>().nullable(),
  allowDisplayInFullScreenMode: yup.boolean()
});
